import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import isToday from "dayjs/plugin/isToday";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import customParseFormat from "dayjs/plugin/customParseFormat";
import weekday from "dayjs/plugin/weekday";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/ko"

dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("ko")
dayjs.extend(updateLocale);
// "하루 전" → "1일 전" 처럼 숫자+단위로 통일
dayjs.updateLocale("ko", {
  relativeTime: {
    future: "%s 후",
    past: "%s 전",
    s: "1초",     // 기본 "몇 초" → "1초"
    m: "1분",
    mm: "%d분",
    h: "1시간",
    hh: "%d시간",
    d: "1일",     // 기본 "하루" → "1일"
    dd: "%d일",
    M: "1개월",   // 기본 "한 달" → "1개월"
    MM: "%d개월",
    y: "1년",     // 기본 "일 년" → "1년"
    yy: "%d년",
  },
});

export const formatDate = (date: string | Date, format = "YYYY-MM-DD") => dayjs(date).format(format);

/**
 * 기간 표기. 시작과 끝의 표기 문자열이 같으면(=하루짜리 일정) 한 번만 노출한다.
 * 원본 값에 시각이 포함돼 있어도 화면에 보이는 형식 기준으로 판단한다.
 */
export const formatDateRange = (
    start: string | Date,
    end: string | Date,
    format = "YYYY-MM-DD",
    separator = " ~ ",
) => {
    const startLabel = formatDate(start, format);
    const endLabel = formatDate(end, format);
    return startLabel === endLabel ? startLabel : `${startLabel}${separator}${endLabel}`;
};

/** 한국식 날짜 포맷 */
export const formatKoreanDate = (date: string | Date, format = "YYYY년 M월 D일") => dayjs(date).format(format);

/** 한국식 날짜 + 요일 포맷 */
export const formatKoDayDate = (date: string | Date, format = "YYYY년 M월 D일(ddd)") => dayjs(date).format(format);

/** 상대 시간 ("1분 전", "3시간 전", "5일 전") */
export const timeAgo = (date: string | Date) => dayjs(date).fromNow();

/** 타임스탬프 변환 */
export const timeStamp = (unixTime: number, format = "YYYY년 M월 D일(ddd) HH:mm") => dayjs.unix(unixTime).format(format);